<template>
    <v-layout>
        <v-navigation-drawer
            permanent
            :mini-variant="rail || isSmall"
            :mini-variant-width="80"
            v-model="drawer"
            style="min-width: 80px;"
        >
            <v-flex style="height: 100%;">
                <v-list-item nav>
                    <v-row>
                        <v-col v-if="!rail && !isSmall" cols="9"></v-col>
                        <v-col cols="3">
                            <div
                                v-if="rail || isSmall"
                                v-on="!isSmall ? { click: toggleRail } : {}"
                                class="logo-circle-container"
                            >
                                <img style="width: 100%; height: 100%;" :src="logo" />
                            </div>
                            <nav-button
                                v-else
                                @click-event="toggleRail"
                                :height="40"
                                :width="40"
                                :iconString="leftChevron"
                                iconType="IMAGE"
                                toolTip="Collapse"
                                :navClick="false"
                                iconColorClass="primary-icon btn-large"
                            ></nav-button>
                        </v-col>
                    </v-row>
                </v-list-item>
                <v-divider></v-divider>
                <v-list nav v-if="settings" style="padding: 0px;">
                    <v-list-item
                        class="vertical-nav-item"
                        v-for="item in settings.navItems"
                        :title="item.label"
                        :value="item._id"
                        :key="item._id"
                        @click="dealRowClick(item.widget, true)"
                    >
                        <v-row style="padding: 0px; margin: 0px;" v-ripple="!rail">
                            <v-list-item-icon
                                :class="{ 'nav-closed-pad': (rail || isSmall), 'nav-open-pad': !rail && !isSmall }"
                            >
                                <site-button
                                    style="height: 100%;"
                                    v-if="item.widget == 'DAILY_DEALS' && (rail || isSmall)"
                                    @click-event="dailyControl(true)"
                                    btnType="text"
                                    iconType="SVG"
                                    colorClasses="primary-icon"
                                    :toolTip="item.label"
                                    :iconString="dailyDealImage"
                                    tool-tip-gravity="BOTTOM"
                                ></site-button>
                                <inline-svg
                                    style="padding: 0.25em;"
                                    v-else-if="item.widget == 'DAILY_DEALS' && !rail"
                                    :src="dailyDealImage"
                                ></inline-svg>

                                <site-button
                                    v-if="item.widget == 'GROUP_DEALS' && (rail || isSmall)"
                                    @click-event="groupControl(true)"
                                    btnType="text"
                                    iconType="SVG"
                                    colorClasses="primary-icon"
                                    :toolTip="item.label"
                                    :iconString="groupDealImage"
                                    tool-tip-gravity="BOTTOM"
                                ></site-button>
                                <inline-svg
                                    style="padding: 0.25em;"
                                    v-else-if="item.widget == 'GROUP_DEALS' && !rail"
                                    :src="groupDealImage"
                                ></inline-svg>

                                <site-button
                                    v-if="item.widget == 'MENU' && (rail || isSmall)"
                                    @click-event="menuControl(true)"
                                    btnType="text"
                                    iconType="SVG"
                                    colorClasses="primary-icon"
                                    :toolTip="item.label"
                                    :iconString="menuImage"
                                    tool-tip-gravity="BOTTOM"
                                ></site-button>
                                <inline-svg
                                    style="padding: 0.25em;"
                                    v-else-if="item.widget == 'MENU' && !rail"
                                    :src="menuImage"
                                ></inline-svg>
                            </v-list-item-icon>
                            <v-list-item-content style="text-align: center;">
                                <span>{{ item.label }}</span>
                            </v-list-item-content>
                        </v-row>
                    </v-list-item>
                </v-list>
                <div class="side-nav-announcement-area" v-if="announcement">
                    <div class="banner-container">
                        <div v-if="!rail && !isSmall">
                            <h2>Announcement</h2>
                            <v-card class="banner">
                                <v-card-title>{{ announcement.title }}</v-card-title>
                                <v-card-text>{{ announcement.text }}</v-card-text>
                            </v-card>
                        </div>
                        <div style="margin-top: auto;" v-else>
                            <site-button
                                @click-event="announceControl(true)"
                                btnType="text"
                                iconType="SVG"
                                colorClasses="primary-icon"
                                toolTip="Announcement"
                                :iconString="notificationImage"
                                tool-tip-gravity="TOP"
                            ></site-button>
                        </div>
                    </div>
                </div>
            </v-flex>
        </v-navigation-drawer>
        <v-main id="attachArea" style="position: relative;">
            <v-flex>
                <div>
                    <photo-carousel :max-height="900" :fullWidth="pageData.carouselType == 'FULL_WIDTH'" :images="pageData.carouselImages"></photo-carousel>
                </div>
                <v-card class="post-area" v-if="businessData && pageData">
                    <div class="post-inner">
                        <v-card-title>{{ businessData.partnerName }} Timeline</v-card-title>
                        <v-card-text>
                            <v-list>
                                <template>
                                    <v-list-item
                                        v-for="(item, index) in pageData.posts"
                                        :key="index"
                                        style="margin: 1.25em 0px;"
                                    >
                                        <post-list-item :key="index" :propPost="item"></post-list-item>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card-text>
                    </div>
                </v-card>
            </v-flex>
            <daily-deal-dialog
                @set-dialog-control="dailyControl"
                :showDialog="openDaily"
                :deals="businessData.dailyDeals"
            ></daily-deal-dialog>
            <menu-dialog
                v-on:setDialogControl="menuControl"
                :editable="false"
                :menuURL="businessData.menuLink"
                title="View Menu"
                :showDialog="openMenu"
            ></menu-dialog>
            <v-menu
                v-if="announcement"
                attach="#attachArea"
                :close-on-content-click="false"
                v-model="openAnnounce"
                fixed
                content-class="announcement-popover"
            >
                <div class="popover-banner">
                    <v-card class="banner">
                        <v-card-title>{{ announcement.title }}</v-card-title>
                        <v-card-text>{{ announcement.text }}</v-card-text>
                    </v-card>
                </div>
            </v-menu>
        </v-main>
    </v-layout>
</template>

<style lang="scss">
@import '../../../styles/styles.scss';
</style>

<script>
// import PageTypeEnums from '../../../assets/Enums/PageTypeEnums'
import { MongoMixins } from '../../../mixins/mongo-mixins'
import PostListItem from '../../../components/common/PostListItem'
import NavButton from '../../../components/navigation/NavButton'
import SiteButton from '../../../components/common/SiteButton'
import PhotoCarousel from '../../../components/common/PhotoCarousel'
import DailyDeal from '../../../components/common/Business/DailyDealDialog'
import Placeholder from '../../../assets/Add-Logo.svg'
import MenuDialog from '../../../components/common/MenuDocDialog'
import SvgInline from 'vue-inline-svg'
import moment from 'moment'

export default {
    name: 'business-page',
    mixins: [MongoMixins],
    components: {
        'nav-button': NavButton,
        'site-button': SiteButton,
        'inline-svg': SvgInline,
        'photo-carousel': PhotoCarousel,
        'daily-deal-dialog': DailyDeal,
        'post-list-item': PostListItem,
        'menu-dialog': MenuDialog
    },
    data: () => ({
        pageData: null,
        businessData: null,
        settings: null,
        rail: false,
        drawer: false,
        openDaily: false,
        openGroup: false,
        openMenu: false,
        openAnnounce: false,
    }),
    props: {
        busId: {
            type: String,
        },
        pageType: {
            type: String,
        },
    },
    async created() {
        console.log('bus ' + this.busId + ' type ' + this.pageType)
        const result = await this.getBusinessPage(this.busId, this.pageType)
        this.pageData = result.data
        this.businessData = result.data.data;
        this.settings = result.data.settings
        console.log('PD: ' + JSON.stringify(result.data))
    },
    methods: {
        dealRowClick(type, state) {
            console.log('type ' + type + ' state ' + state)
            if (type == 'DAILY_DEALS') {
                this.openDaily = state
            } else if (type == 'GROUP_DEALS') {
                this.openGroup = state
            } else if (type == 'MENU') {
                this.openMenu = state
            }
        },
        toggleRail() {
            this.rail = !this.rail
            console.log(this.rail)
        },
        formatDate(date) {
            return moment(date).format('MM.DD.YYYY H a')
        },
        dailyControl(state) {
            this.openDaily = state
            console.log(this.openDaily)
        },
        groupControl(state) {
            this.openGroup = state
            console.log(this.openGroup)
        },
        menuControl(state) {
            this.openMenu = state
            console.log('menu ' + state)
        },
        announceControl(state) {
            this.openAnnounce = state
            console.log('announce ' + state)
        },
    },
    computed: {
        logo() {
            return this.settings && this.settings.logoImage
                ? `${process.env.VUE_APP_BUS_API_URL}/image-host?pid=${this.settings.logoImage}`
                : Placeholder
        },
        topNav() {
            return !!this.settings && this.settings.navArea == 'TOP'
        },
        rightNav() {
            return !!this.settings && this.settings.navArea == 'RIGHT'
        },
        announcement() {
            return this.pageData.announcement;
        },
        leftNav() {
            return !!this.settings && this.settings.navArea == 'LEFT'
        },
        leftChevron() {
            return require('../../../assets/Chevron-Left.svg')
        },
        dailyDealImage() {
            return require('../../../assets/Daily-Deals.svg')
        },
        groupDealImage() {
            return require('../../../assets/Group-Deals.svg')
        },
        notificationImage() {
            return require('../../../assets/Notifications.svg')
        },
        menuImage() {
            return require('../../../assets/Menu-Icon-Small.svg')
        },
        hasMenu() {
            return !!this.businessData.menuLink
        },
        isSmall() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return true
                case 'sm':
                    return true
                default:
                    return false
            }
        },
    },
}
</script>
